var _a;
import { KpiType } from '../models';
export var IMPACT_MENU_ICON_URL = 'https://planter-assets.s3.eu-central-1.amazonaws.com/icons/impact.svg';
export var IMPACT_ICONS_MAP = (_a = {},
    _a[KpiType.WATER] = 'https://planter-assets.s3.eu-central-1.amazonaws.com/icons/impactWater.svg',
    _a[KpiType.CO2] = 'https://planter-assets.s3.eu-central-1.amazonaws.com/icons/impactCo2.svg',
    _a[KpiType.ANIMALS_SAVED] = 'https://planter-assets.s3.eu-central-1.amazonaws.com/icons/impactAnimals.svg',
    _a[KpiType.FOREST_PROTECTED] = 'https://planter-assets.s3.eu-central-1.amazonaws.com/icons/impactForest.svg',
    _a[KpiType.GRAIN] = 'https://planter-assets.s3.eu-central-1.amazonaws.com/icons/impactGrain.svg',
    _a);
